/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'

import { useSiteConfig } from '../../lib/siteconfig'
import { Menu as MenuType, usePageConfig } from '../PageConfig/PageConfigProvider'
import Footer, { LinkProps, LinksGroupProps } from './Footer'

const extractMenuItems = (menu?: MenuType) => {
  const items: LinkProps[] = []
  menu?.menuItems?.nodes?.forEach(menuItem => {
    if (menuItem?.label && menuItem?.url) {
      items.push({ href: menuItem.url, name: menuItem.label })
    }
  })
  return items
}

const generateBottomLinks = (menu?: MenuType, siteTitle?: string) => {
  const items = extractMenuItems(menu)
  if (!items.length) {
    return { left: [], middle: [], right: [] }
  }

  const middleIdx = Math.floor(items.length / 2)
  const left = items.slice(0, middleIdx)
  const right = items.slice(middleIdx, items.length)
  const d = new Date()
  const year = d.getFullYear()

  return {
    left,
    middle: [{ name: `Copyright © ${year} - ${siteTitle || 'Web Summit'}` }],
    right,
  }
}

const generateLinkGroups = (menus: (MenuType | undefined)[]) => {
  const groups: LinksGroupProps[] = []
  menus.forEach(menu => {
    const items = extractMenuItems(menu)
    if (menu?.name && items.length > 0) {
      groups.push({
        items,
        name: menu.name,
      })
    }
  })
  return groups
}

const FooterProvider = () => {
  const { siteTitle } = useSiteConfig()
  const {
    menus: { bottom, footer1, footer2, footer3, footer4 },
  } = usePageConfig()

  const bottomLinks = generateBottomLinks(bottom, siteTitle)
  const linkGroups = generateLinkGroups([footer1, footer2, footer3, footer4])

  return (
    <>
      <Footer bottomLinks={bottomLinks} linkGroups={linkGroups} />
    </>
  )
}

export default FooterProvider
